import { render, staticRenderFns } from "./HuaxianColumnar.vue?vue&type=template&id=5a0daf9e&scoped=true&"
import script from "./HuaxianColumnar.vue?vue&type=script&lang=js&"
export * from "./HuaxianColumnar.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianColumnar.vue?vue&type=style&index=0&id=5a0daf9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0daf9e",
  null
  
)

export default component.exports